import { render, staticRenderFns } from "./v-custom-workflow.vue?vue&type=template&id=7a643d28&"
import script from "./v-custom-workflow.vue?vue&type=script&lang=js&"
export * from "./v-custom-workflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports